"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_VISIBLE_COLUMNS = exports.currencyColumns = exports.CURRENCY_LIMIT = void 0;
var CURRENCY_LIMIT = 10;
exports.CURRENCY_LIMIT = CURRENCY_LIMIT;
var currencyColumns = [
    { name: "Icon", uid: "icon" },
    { name: "Name", uid: "name" },
    { name: "Code", uid: "code" },
    { name: "Type", uid: "type" },
    { name: "Conversion Rate", uid: "conversion_rate" },
    { name: "Actions", uid: "actions" },
];
exports.currencyColumns = currencyColumns;
var INITIAL_VISIBLE_COLUMNS = currencyColumns.map(function (column) { return column.uid; });
exports.INITIAL_VISIBLE_COLUMNS = INITIAL_VISIBLE_COLUMNS;
